(function(){
function init(){
  if(document.querySelector('[data-mm-personalization][data-mm-mode="native"]'))return;
  if(document.querySelector('.mm-v23-bar'))return;
  var section=document.querySelector('section.product') || document.querySelector('[data-product-id]') || document;
  var form=document.querySelector('form.buy-buttons__form') || document.querySelector('form[action*="/cart/add"]');
  if(!form)return;
  var root=document.querySelector('[data-mm-personalization]');
  // Fallback if the theme's product form does not render the Liquid snippet.
  if(!root && document.getElementById('mm-v23-product-data') &&
     document.getElementById('mm-v23-product-data').textContent.indexOf('happy-horse-knuffelkonijn')!==-1){
    root=document.createElement('div');
    root.className='mm-hh';
    root.setAttribute('data-mm-personalization','');
    root.dataset.mmMode='native';
    root.innerHTML='<h3>Maak jouw knuffel persoonlijk</h3><div data-mm-ear-one hidden><label for="mm-hh-name">Oor 1 – Naam *</label><input id="mm-hh-name" name="properties[Oor 1 – naam]" placeholder="Bijvoorbeeld: Noor" maxlength="24" disabled></div><div data-mm-ear-two hidden><label for="mm-hh-date">Oor 2 – Geboortedatum of tekst *</label><input id="mm-hh-date" name="properties[Oor 2 – geboortedatum of tekst]" placeholder="Bijvoorbeeld: 14-10-2026" maxlength="24" disabled></div>';
    var picker=document.querySelector('[data-component="block-variant-picker"]');
    if(picker)picker.insertAdjacentElement('afterend',root);
    else form.insertAdjacentElement('afterbegin',root);
  }
  var variantsElement=document.querySelector('[data-mm-sticky-price] + script[type="application/json"]');
  // Shopify's product JSON embedded by Liquid, not a guessed product price.
  var data=document.getElementById('mm-v23-product-data');
  var variants=[];
  try{variants=JSON.parse(data.textContent).variants || []}catch(e){}
  var bar=document.createElement('div');
  bar.className='mm-v23-bar';
  bar.innerHTML='<div><span class="mm-v23-bar__label">Totaalprijs</span><strong class="mm-v23-bar__price" aria-live="polite"></strong></div><button type="button" class="mm-v23-bar__button">In winkelwagen</button>';
  document.body.appendChild(bar);
  document.body.classList.add('mm-v23-product');
  var price=bar.querySelector('.mm-v23-bar__price'), button=bar.querySelector('button');
  var money=new Intl.NumberFormat('nl-NL',{style:'currency',currency:'EUR'});
  var first=root&&root.querySelector('#mm-hh-name'),second=root&&root.querySelector('#mm-hh-date');
  if(root && form && !form.getAttribute('id'))form.setAttribute('id','mm-v25-cart-form');
  var mmFormId=form.getAttribute('id');
  if(root && mmFormId){
    if(first)first.setAttribute('form',mmFormId);
    if(second)second.setAttribute('form',mmFormId);
  }
  var one=root&&root.querySelector('[data-mm-ear-one]'),two=root&&root.querySelector('[data-mm-ear-two]');
  var error=root&&root.querySelector('[data-mm-hh-error]');
  function selectedOptions(){
    var result={};
    // This theme renders native radio buttons with name="Bedrukking<SECTION_ID>"
    // directly inside .option-selectable-boxes, NOT .variant-picker.
    document.querySelectorAll('input[type="radio"]:checked, select').forEach(function(el){
      var val=String(el.value||'').trim();
      var key=String(el.name||'').toLowerCase();
      if(key.indexOf('bedrukking')>=0 || /^(zonder bedrukking|[12]\s*(?:oor|oren)\s*bedrukken)$/i.test(val)) result.print=val;
      if(key.indexOf('kleur')>=0 || key.indexOf('color')>=0)result.color=val;
    });
    return result;
  }
  function chosenVariant(){
    var choices=Array.from(section.querySelectorAll('[data-component="block-variant-picker"] input[type="radio"]:checked, [data-component="block-variant-picker"] select:not([name="id"])')).map(function(input){return String(input.value||'').trim();}).filter(Boolean);
    var selected=choices.length&&variants.find(function(variant){return choices.every(function(choice){return (variant.options||[]).some(function(option){return String(option)===choice;});});});
    if(selected)return selected;
    var id=Array.from(section.querySelectorAll('[name="id"]')).find(function(input){return input.form===form;});
    var matched=variants.find(function(v){return id&&String(v.id)===String(id.value)});
    return matched || variants[0];
  }
  function visibleChoice(optionName){
    var nodes=document.querySelectorAll('.variant-picker *');
    for(var i=0;i<nodes.length;i++){
      var el=nodes[i];
      if(el.children.length>3)continue;
      var t=(el.textContent||'').replace(/\s+/g,' ').trim();
      if(t.toLowerCase().indexOf(optionName.toLowerCase()+':')===0){
        var value=t.slice(t.indexOf(':')+1).trim();
        if(value.length<70)return value;
      }
    }
    return '';
  }
  var mmClickedPrint=null;
  function countFromText(text){
    text=String(text||'').replace(/\s+/g,' ').toLowerCase();
    if(/2\s*oren\s*bedrukken/.test(text))return 2;
    if(/1\s*oor\s*bedrukken/.test(text))return 1;
    if(/zonder\s*bedrukking/.test(text))return 0;
    return null;
  }
  function printCount(){
    if(mmClickedPrint!==null)return mmClickedPrint;
    if(!root)return 0;
    var val=visibleChoice('Bedrukking');
    if(/2\s*oren\s*bedrukken/i.test(val))return 2;
    if(/1\s*oor\s*bedrukken/i.test(val))return 1;
    if(/zonder\s*bedrukking/i.test(val))return 0;
    // Also support directly checked theme inputs.
    var checked=document.querySelectorAll('.option-selectable-boxes input:checked');
    for(var i=0;i<checked.length;i++){
      var v=checked[i].value||'';
      if(/2\s*oren\s*bedrukken/i.test(v))return 2;
      if(/1\s*oor\s*bedrukken/i.test(v))return 1;
      if(/zonder\s*bedrukking/i.test(v))return 0;
    }
    var v=chosenVariant(),title=v&&((v.options||[]).join(' ')+' '+(v.title||''))||'';
    return /2\s*oren\s*bedrukken/i.test(title)?2:/1\s*oor\s*bedrukken/i.test(title)?1:0;
  }
  function update(){
    var v=chosenVariant(),count=printCount();
    if(root){
      // Ear input visibility is handled solely by mm-ear-fields-v30.js.
      if(error)error.hidden=true;
      [first,second].filter(Boolean).forEach(function(f){if(!f.required||f.disabled)f.setCustomValidity('');});
    }
    if(root && variants.length){
      var color=visibleChoice('Kleur').toLowerCase();
      var desired=count===2?'2 oren bedrukken':count===1?'1 oor bedrukken':'zonder bedrukking';
      var found=variants.find(function(item){
        var opts=(item.options||[]).map(function(x){return String(x).toLowerCase()});
        return opts.includes(desired) && (!color || opts.includes(color));
      });
      if(found)v=found;
    }
    // Knuffeldoekje: prijs direct uit de werkelijk gekozen kleur + bedrukking-variant.
    // De originele konijnenlogica hieronder blijft ongewijzigd.
    if(document.querySelector('[data-mm-cloth-name]') && variants.length){
      var picked=selectedOptions();
      var printChoice=picked.print;
      var current=form.querySelector('[name="id"]');
      var byId=variants.find(function(item){return current&&String(item.id)===String(current.value)});
      if(!printChoice){
        var radios=document.querySelectorAll('.option-selectable-boxes input[type="radio"]:checked');
        for(var ri=0;ri<radios.length;ri++){
          if(/^(met naam bedrukken|zonder bedrukking)$/i.test(String(radios[ri].value).trim())){
            printChoice=radios[ri].value;break;
          }
        }
      }
      var wanted=String(printChoice||'').toLowerCase();
      var color=String(picked.color||'').toLowerCase();
      var clothMatch=variants.find(function(item){
        var opts=(item.options||[]).map(function(o){return String(o).toLowerCase()});
        return (!wanted||opts.includes(wanted))&&(!color||opts.includes(color));
      });
      if(wanted&&clothMatch)v=clothMatch;
      else if(byId)v=byId;
      else if(clothMatch)v=clothMatch;
    }
    var cents=v?Number(v.price):0;
    if(root){
      // On the original Happy Horse product, the print option is a native
      // Shopify variant: €18.99 / €26.98 / €31.97. Never add addon prices twice.
      // The V30 ear-field controller is the single source of truth for the
      // customer's selected number of printed ears.
      var earState=root.getAttribute('data-mm-ear-count');
      if(earState==='0'||earState==='1'||earState==='2')count=Number(earState);
      if(root.dataset.mmMode==='native'){
        var desired=count===2?'2 oren bedrukken':count===1?'1 oor bedrukken':'zonder bedrukking';
        var nativeMatch=variants.find(function(item){
          var opts=(item.options||[]).map(function(x){return String(x).toLowerCase()});
          var color=visibleChoice('Kleur').toLowerCase();
          return opts.includes(desired) && (!color||opts.includes(color));
        });
        // Prices are sourced from Shopify's variant JSON, not calculated
        // from text entry. This keeps the bar consistent with checkout.
        if(!nativeMatch)nativeMatch=variants.find(function(item){
          return (item.options||[]).some(function(x){return String(x).toLowerCase()===desired});
        });
        if(nativeMatch){cents=Number(nativeMatch.price);v=nativeMatch;}
      }else if(root.dataset.mmMode==='addons'){
        cents+=(count>=1?799:0)+(count>=2?499:0);
      }
    }
    price.textContent=money.format(cents/100);
    button.disabled=mmAdding || !!(v&&!v.available);
    if(!mmAdding)button.textContent='In winkelwagen';
  }
  function validate(){
    if(!root)return true;
    var count=printCount();
    if(count>=1&&!first.value.trim()){first.setCustomValidity('Vul de naam voor oor 1 in.');first.reportValidity();first.focus();return false}
    if(count>=2&&!second.value.trim()){second.setCustomValidity('Vul de tekst voor oor 2 in.');second.reportValidity();second.focus();return false}
    return true;
  }
  [first,second].filter(Boolean).forEach(function(input){
    input.addEventListener('input',function(){input.setCustomValidity('');update()});
    input.addEventListener('keydown',function(e){if(e.key==='Enter'){e.preventDefault();e.stopImmediatePropagation();input.blur()}},true);
  });
  form.addEventListener('submit',function(e){
    if(!validate()){e.preventDefault();e.stopImmediatePropagation()}
  },true);
  // V56: direct Shopify Ajax cart submit; onafhankelijk van de door het
  // thema opnieuw gerenderde/disabled originele koopknop.
  var mmAdding=false;
  function mmPrintOption(v){
    return (v.options||[]).map(function(x){return String(x).toLowerCase().trim()});
  }
  function mmCurrentVariant(){
    var selected=chosenVariant();
    var picker=document.querySelector('.option-selectable-boxes') || document;
    var chosen=Array.from(picker.querySelectorAll('input[type="radio"]:checked'));
    var printValue='',colorValue='';
    chosen.forEach(function(el){
      var name=String(el.name||'').toLowerCase();
      var value=String(el.value||'').toLowerCase().trim();
      if(name.indexOf('bedrukking')>=0 || /^(zonder bedrukking|met naam bedrukken|[12] (oor|oren) bedrukken)$/.test(value))printValue=value;
      if(name.indexOf('kleur')>=0||name.indexOf('color')>=0)colorValue=value;
    });
    if(root){
      var ears=root.getAttribute('data-mm-ear-count');
      var n=(ears==='0'||ears==='1'||ears==='2')?Number(ears):printCount();
      printValue=n===2?'2 oren bedrukken':n===1?'1 oor bedrukken':'zonder bedrukking';
    }
    var matches=variants.filter(function(v){
      var opts=mmPrintOption(v);
      return (!printValue || opts.includes(printValue)) && (!colorValue || opts.includes(colorValue));
    });
    if(matches.length===1)return matches[0];
    if(matches.length>1 && selected && matches.some(function(v){return String(v.id)===String(selected.id)}))return selected;
    if(matches.length)return matches[0];
    return selected;
  }
  function mmError(message,field){
    var err=error || document.querySelector('[data-mm-cloth-error]');
    if(err){err.textContent=message;err.hidden=false;}
    if(field){field.setCustomValidity(message);field.reportValidity();field.focus();}
    else window.alert(message);
  }
  button.addEventListener('click',async function(event){
    event.preventDefault();
    if(mmAdding||button.disabled)return;
    var cloth=document.querySelector('[data-mm-cloth-name]');
    var clothInput=cloth&&cloth.querySelector('[data-mm-cloth-input]');
    var count=root?(Number(root.getAttribute('data-mm-ear-count'))||0):0;
    if(root){
      if(count>=1 && (!first||!first.value.trim())){
        mmError('Vul de naam voor oor 1 in.',first);return;
      }
      if(count>=2 && (!second||!second.value.trim())){
        mmError('Vul de tekst voor oor 2 in.',second);return;
      }
    }
    var variant=mmCurrentVariant();
    if(!variant||!variant.id){mmError('Kies eerst een uitvoering van het product.');return;}
    if(variant.available===false){mmError('Deze uitvoering is momenteel niet op voorraad.');return;}
    if(clothInput){
      var personalized=mmPrintOption(variant).some(function(opt){return opt==='met naam bedrukken';});
      if(personalized&&!clothInput.value.trim()){
        mmError('Vul de naam in voor bedrukking.',clothInput);return;
      }
    }
    // Collect only valid active line-item properties, including fields that
    // are associated with the form via their HTML form attribute.
    var props={};
    new FormData(form).forEach(function(val,key){
      var m=/^properties\[(.*)\]$/.exec(key);
      if(m && String(val).trim())props[m[1]]=String(val);
    });
    if(root){
      delete props['Oor 1 – naam'];delete props['Oor 2 – geboortedatum of tekst'];
      if(count>=1)props['Oor 1 – naam']=first.value.trim();
      if(count>=2)props['Oor 2 – geboortedatum of tekst']=second.value.trim();
    }
    if(clothInput){
      delete props['Naam op knuffeldoekje'];
      if(mmPrintOption(variant).includes('met naam bedrukken'))props['Naam op knuffeldoekje']=clothInput.value.trim();
    }
    if(error)error.hidden=true;
    if(cloth){var clothError=cloth.querySelector('[data-mm-cloth-error]');if(clothError)clothError.hidden=true;}
    mmAdding=true;button.disabled=true;button.setAttribute('aria-busy','true');
    var label=button.textContent;button.textContent='Toevoegen…';
    try{
      var base=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
      var response=await fetch(base+'cart/add.js',{
        method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({items:[{id:Number(variant.id),quantity:1,properties:props}]})
      });
      if(!response.ok){var data=await response.json().catch(function(){return {};});throw new Error(data.description||data.message||'Toevoegen aan winkelwagen is mislukt.');}
      resetCartButton();
      window.location.assign(base+'cart');
    }catch(e){resetCartButton();mmError(e.message||'Toevoegen mislukt. Probeer het opnieuw.');}
  });
  function resetCartButton(){
    mmAdding=false;
    button.textContent='In winkelwagen';
    button.removeAttribute('aria-busy');
    update();
  }
  window.addEventListener('pageshow',resetCartButton);
  // Capture the customer's actual click before the theme re-renders its picker.
  // Keep that choice until another printing choice is explicitly selected.
  document.addEventListener('click',function(e){
    var target=e.target.closest('label,button,[role="radio"],.option-selectable-boxes__item,.option-selectable-boxes__option');
    if(!target)return;
    var choice=countFromText(target.textContent);
    if(choice===null && target.getAttribute('for')){
      var radio=document.getElementById(target.getAttribute('for'));
      if(radio)choice=countFromText(radio.value);
    }
    if(choice===null && target.querySelector){
      var inp=target.querySelector('input');if(inp)choice=countFromText(inp.value);
    }
    if(choice!==null){mmClickedPrint=choice;update();setTimeout(update,80);setTimeout(update,250);}
  },true);
  document.addEventListener('change',function(e){
    var c=countFromText(e.target.value);
    if(c!==null)mmClickedPrint=c;
    update();setTimeout(update,0);setTimeout(update,150);
  },true);
  document.addEventListener('click',function(e){if(e.target.closest('.option-selectable-boxes'))setTimeout(update,0)},true);
  document.addEventListener('input',function(){setTimeout(update,0)},true);
  document.addEventListener('variant:change',update);
  document.addEventListener('mm:ear-selection-change',update);
  document.addEventListener('click',function(){update();setTimeout(update,80);setTimeout(update,250)},true);
  var variantInput=form.querySelector('[name="id"]');
  if(variantInput)new MutationObserver(update).observe(variantInput,{attributes:true,attributeFilter:['value']});
  update();
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
document.addEventListener('shopify:section:load',init);
})();
